"use client";

import React from "react";
import { Lightbulb, PenTool, LayoutGrid, Share2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "strategy",
  title: "Audyt",
  description: "Identyfikujemy słabe punkty Twojej strategii zanim staną się kosztownymi błędami.",
  icon: Lightbulb,
  link: "/ServicesPage"
}, {
  id: "creative",
  title: "Strategia",
  description: "Budujemy strategie skrojone pod pozycję, którą chcesz zajmować - nie tę, którą zajmujesz dziś.",
  icon: PenTool,
  link: "/ServicesPage"
}, {
  id: "design",
  title: "Design",
  description: "Projektujemy identyfikację wizualną i materiały komunikacji marki - od kampanii digital po realizacje offline.",
  icon: LayoutGrid,
  link: "/ServicesPage"
}, {
  id: "social",
  title: "Reputacja",
  description: "Dbamy o to, żeby to, co mówi się o Twojej marce w sieci, było spójne z tym, na co zapracowałeś.",
  icon: Share2,
  link: "/ServicesPage"
}];
export default function OurServicesApproachGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-services-approach-grid" className="bg-background py-12 md:py-16 px-6 md:px-8">
      <div ref={ref} className="container mx-auto">
        <div className={`mb-8 w-full transition-all duration-1000 cubic-bezier(0.16, 1, 0.3, 1) ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-sm font-mono uppercase tracking-widest text-primary mb-4">NASZA EKSPERTYZA</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight font-sans">Precyzja w każdym obszarze.&nbsp;<span className="text-primary" data-ast-id="f:/src/pages/Homepage/sections/OurServicesApproachGrid.tsx|sig:p8yc2l" data-ast-start="1762" data-ast-end="1815"> Od strategii do realizacji.</span></h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={service.id} data-index={i} style={{
            transitionDelay: `${i * 150}ms`
          }} className={`group relative bg-card rounded-3xl p-8 border border-border shadow-sm hover:shadow-lg hover:border-primary/20 transition-all duration-700 cubic-bezier(0.16, 1, 0.3, 1) flex flex-col h-full overflow-hidden ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-primary/5 rounded-lg blur-2xl group-hover:bg-primary/10 transition-colors duration-500" />
                
                <div className="relative z-10">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-primary stroke-[2px]" />
                  </div>
                  
                  <h4 className="text-2xl font-bold text-foreground mb-3 font-sans">
                    {service.title}
                  </h4>
                  
                  <p className="text-muted-foreground leading-relaxed mb-8 flex-grow">
                    {service.description}
                  </p>
                  
                  <Button asChild variant="ghost" className="p-0 h-auto text-primary hover:bg-transparent hover:text-primary/80 group/btn flex items-center gap-2 font-semibold transition-all duration-300">
                    <Link to={service.link}>
                      Jak to działa?
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                </div>
              </div>;
        })}
        </div>

        <div className={`mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Button asChild size="lg" className="rounded-lg px-8 py-6 text-lg font-semibold hover:scale-105 transition-transform duration-300 shadow-md">
            <Link to="/ServicesPage">Zobacz naszą ofertę</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-lg px-8 py-6 text-lg font-semibold hover:scale-105 transition-transform duration-300 shadow-md">
            <Link to="/ContactPage">Rozpocznij Projekt</Link>
          </Button>
        </div>
      </div>
    </section>;
}